/* Olilu chrome: header (mega menus, hide on scroll, basket count), phone menu sheet, predictive search,
   footer accordions and the Letters band. Needs assets/olilu.js (window.Olilu), loaded before it.
   Loaded by sections/site-header, site-footer and letters-band; it runs once. */
(function () {
  'use strict';
  var O = window.Olilu;
  if (!O || O.__chrome) return;
  O.__chrome = true;

  var $ = O.$, $$ = O.$$;
  var desktop = window.matchMedia('(min-width: 1200px)');
  function onChange(mq, fn) {
    if (mq.addEventListener) mq.addEventListener('change', fn);
    else if (mq.addListener) mq.addListener(fn);
  }

  /* ---------- Basket count ---------- */
  function setCount(n) {
    n = Number(n) || 0;
    $$('[data-basket-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; });
    $$('[data-basket-link]').forEach(function (a) { a.setAttribute('aria-label', 'Basket, ' + n + (n === 1 ? ' item' : ' items')); });
  }
  document.addEventListener('olilu:cart', function (e) {
    if (e.detail && e.detail.cart) setCount(e.detail.cart.item_count);
  });
  // A page restored from the back-forward cache can show an old count
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && O.cart && O.cart.get) O.cart.get().then(function (c) { setCount(c.item_count); }).catch(function () {});
  });

  /* ---------- Header ---------- */
  O.ready('[data-hdr]', function (hdr) {
    var section = hdr.closest('.shopify-section') || hdr;
    var root = document.documentElement;

    // Drawers move to <body> when first opened: drop stale copies left by a theme-editor reload
    ['MenuSheet', 'SearchSheet'].forEach(function (id) {
      $$('body > [id="' + id + '"]').forEach(function (d) { if (!section.contains(d)) d.remove(); });
    });

    /* Mega panels and dropdowns: open on hover after 120ms (instantly when switching), close 150ms after leaving */
    var items = $$('[data-hdr-item]', hdr);
    var current = null, openTimer = null, closeTimer = null, pointer = 'mouse';

    function setExpanded(li, on) {
      $$('[data-hdr-trigger], [data-hdr-caret]', li).forEach(function (el) { el.setAttribute('aria-expanded', on ? 'true' : 'false'); });
    }
    function open(li) {
      clearTimeout(closeTimer);
      if (current === li) return;
      if (current) close(current);
      li.classList.add('is-open');
      setExpanded(li, true);
      current = li;
      setHidden(false);
    }
    function close(li) {
      if (!li) return;
      li.classList.remove('is-open');
      setExpanded(li, false);
      if (current === li) current = null;
    }
    function firstLink(li) {
      var panel = $('[data-hdr-panel]', li);
      return panel ? O.focusables(panel)[0] : null;
    }

    // Start loading the panel pictures as soon as the pointer or focus reaches the nav, so no panel opens on empty frames
    var nav = $('.hdr__nav', hdr);
    function warm() {
      $$('.mega img[loading="lazy"]', hdr).forEach(function (img) { img.loading = 'eager'; });
      nav.removeEventListener('pointerenter', warm);
      nav.removeEventListener('focusin', warm);
    }
    if (nav) {
      nav.addEventListener('pointerenter', warm);
      nav.addEventListener('focusin', warm);
    }

    hdr.addEventListener('pointerdown', function (e) { pointer = e.pointerType || 'mouse'; }, true);
    hdr.addEventListener('pointermove', function (e) { if (e.pointerType === 'mouse') pointer = 'mouse'; });

    items.forEach(function (li) {
      var trigger = $('[data-hdr-trigger]', li);
      var caret = $('[data-hdr-caret]', li);

      li.addEventListener('mouseenter', function () {
        if (pointer === 'touch' || !desktop.matches) return;
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
        openTimer = setTimeout(function () { open(li); }, current ? 0 : 120);
      });
      li.addEventListener('mouseleave', function () {
        if (pointer === 'touch') return;
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () { close(li); }, 150);
      });
      li.addEventListener('focusout', function (e) {
        if (e.relatedTarget && !li.contains(e.relatedTarget)) close(li);
      });

      if (trigger) {
        // On touch screens the first tap opens the panel, the second follows the link
        trigger.addEventListener('click', function (e) {
          if (pointer === 'touch' && current !== li) { e.preventDefault(); open(li); }
        });
        trigger.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            open(li);
            var f = firstLink(li);
            if (f) f.focus();
          }
        });
      }
      if (caret) {
        caret.addEventListener('click', function () {
          if (current === li) { close(li); return; }
          open(li);
          var f = firstLink(li);
          if (f) f.focus();
        });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !current) return;
      var li = current, t = $('[data-hdr-trigger]', li);
      var inside = li.contains(document.activeElement);
      close(li);
      if (inside && t) t.focus();
    });
    document.addEventListener('click', function (e) {
      if (current && !current.contains(e.target)) close(current);
    });
    onChange(desktop, function () { if (!desktop.matches && current) close(current); });

    // Theme editor: show a panel while its block is selected
    document.addEventListener('shopify:block:select', function (e) {
      var li = e.target.closest && e.target.closest('[data-hdr-item]');
      if (li && hdr.contains(li)) open(li);
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      var li = e.target.closest && e.target.closest('[data-hdr-item]');
      if (li && hdr.contains(li)) close(li);
    });

    /* Hide on scroll down (after 200px) and return on scroll up: desktop only */
    var lastY = window.pageYOffset || 0, ticking = false;
    function setHidden(on) {
      if (section.classList.contains('is-hidden') === on) return;
      section.classList.toggle('is-hidden', on);
      root.classList.toggle('hdr-hidden', on);
    }
    function keyboardInside() {
      try { return !!hdr.querySelector(':focus-visible'); } catch (err) { return false; }
    }
    function onScroll() {
      ticking = false;
      var y = window.pageYOffset || 0;
      if (!desktop.matches || current || document.body.classList.contains('is-locked') || keyboardInside()) setHidden(false);
      else if (y > 200 && y > lastY + 4) setHidden(true);
      else if (y < lastY - 4 || y <= 200) setHidden(false);
      lastY = y;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(onScroll); }
    }, { passive: true });
    hdr.addEventListener('focusin', function () { setHidden(false); });
    onChange(desktop, function () { if (!desktop.matches) setHidden(false); });
  });

  /* ---------- Phone menu sheet: drill-down panels ---------- */
  O.ready('[data-msheet]', function (sheet) {
    var rootPanel = $('[data-msheet-panel="root"]', sheet);
    var body = $('.msheet__body', sheet);
    var openPanel = null, opener = null;

    function show(panel, from) {
      if (!rootPanel) return;
      rootPanel.hidden = true;
      panel.hidden = false;
      openPanel = panel;
      opener = from || null;
      if (opener) opener.setAttribute('aria-expanded', 'true');
      if (body) body.scrollTop = 0;
      var back = $('[data-msheet-back]', panel);
      if (back) back.focus({ preventScroll: true });
    }
    function reset(focusOpener) {
      if (!openPanel) return;
      openPanel.hidden = true;
      if (rootPanel) rootPanel.hidden = false;
      openPanel = null;
      if (opener) {
        opener.setAttribute('aria-expanded', 'false');
        if (focusOpener) opener.focus({ preventScroll: true });
      }
      opener = null;
    }

    sheet.addEventListener('click', function (e) {
      var o = e.target.closest('[data-msheet-open]');
      if (o) {
        var p = document.getElementById(o.getAttribute('data-msheet-open'));
        if (p && sheet.contains(p)) show(p, o);
        return;
      }
      if (e.target.closest('[data-msheet-back]')) {
        reset(true);
        if (body) body.scrollTop = 0;
      }
    });
    sheet.addEventListener('drawer:close', function () {
      setTimeout(function () { if (!sheet.classList.contains('is-open')) reset(false); }, 340);
    });
    onChange(desktop, function () { if (desktop.matches && O.drawer) O.drawer.close(sheet); });
  });

  /* ---------- Predictive search (search sheet and phone menu) ---------- */
  O.ready('[data-psr-form]', function (form) {
    var input = $('input[name="q"]', form);
    var out = document.getElementById(form.getAttribute('data-psr-target'));
    var host = form.closest('[data-psr-host]') || form.parentNode;
    if (!input || !out) return;
    var empty = $('[data-psr-empty]', host);
    var status = $('[data-psr-status]', host);
    var base = (O.cfg && O.cfg.routes && O.cfg.routes.predictiveSearch) || '/search/suggest';
    var ctrl = null, lastQ = '';

    function clear() {
      out.innerHTML = '';
      host.classList.remove('is-searching');
      if (empty) empty.hidden = false;
      if (status) status.textContent = '';
    }
    function render(html, q) {
      var res = O.parse(html).querySelector('[data-psr]');
      out.innerHTML = res ? res.outerHTML : '';
      host.classList.toggle('is-searching', !!res);
      if (empty) empty.hidden = !!res;
      if (status) {
        var n = res ? Number(res.getAttribute('data-psr-total')) || 0 : 0;
        status.textContent = n ? n + (n === 1 ? ' suggestion for ' : ' suggestions for ') + q : 'No results for ' + q;
      }
    }
    var run = O.debounce(function () {
      var q = input.value.trim();
      if (q === lastQ) return;
      lastQ = q;
      if (ctrl) ctrl.abort();
      ctrl = null;
      if (q.length < 2) { clear(); form.classList.remove('is-loading'); return; }
      if ('AbortController' in window) ctrl = new AbortController();
      form.classList.add('is-loading');
      var url = base + '?q=' + encodeURIComponent(q) +
        '&section_id=predictive-search&resources[type]=product,collection,page&resources[limit]=6&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last';
      fetch(url, { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          if (q === input.value.trim()) render(html, q);
          form.classList.remove('is-loading');
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          form.classList.remove('is-loading');
          clear();
        });
    }, 220);
    input.addEventListener('input', run);
    input.addEventListener('search', run);

    // Arrow keys move between the field and the result links
    function links() { return $$('a[href]', out); }
    input.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown') return;
      var l = links();
      if (l.length) { e.preventDefault(); l[0].focus(); }
    });
    out.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var l = links(), i = l.indexOf(document.activeElement);
      if (i < 0) return;
      e.preventDefault();
      if (e.key === 'ArrowDown') { if (l[i + 1]) l[i + 1].focus(); }
      else if (i === 0) input.focus();
      else l[i - 1].focus();
    });
  });

  /* ---------- Footer: accordions on phones, open columns from 750px ---------- */
  O.ready('[data-ftr]', function (ftr) {
    var cols = $$('[data-ftr-col]', ftr);
    var wide = window.matchMedia('(min-width: 750px)');
    function apply() {
      cols.forEach(function (d) {
        var s = $('summary', d);
        d.open = wide.matches;
        if (!s) return;
        if (wide.matches) s.setAttribute('tabindex', '-1');
        else s.removeAttribute('tabindex');
      });
    }
    apply();
    onChange(wide, apply);
  });

  /* ---------- Letters band: announce the result after the form posts ---------- */
  O.ready('[data-letters]', function (band) {
    var msg = $('[data-letters-msg]', band);
    if (!msg) return;
    var form = $('form', band);
    var posted = /[?&]customer_posted=true/.test(location.search) || (form && form.id && location.hash === '#' + form.id);
    if (!posted && !msg.classList.contains('form-msg--error')) return;
    window.requestAnimationFrame(function () {
      band.scrollIntoView({ block: 'center' });
      msg.focus({ preventScroll: true });
    });
  });
})();
